import { render } from "./PromoteNext.vue?vue&type=template&id=55503523&scoped=true"
import script from "./PromoteNext.vue?vue&type=script&lang=js"
export * from "./PromoteNext.vue?vue&type=script&lang=js"

import "./PromoteNext.vue?vue&type=style&index=0&id=55503523&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55503523"]])

export default __exports__